"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _page = require("./page");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Helpers for extracting Footer props from the contentful section, global-footer
 */
var getInContentWithID = function getInContentWithID(content, id, path) {
  return _lodash["default"].get(_lodash["default"].find(content, {
    fields: {
      id: id
    }
  }), path);
};

var getFooterText = function getFooterText(content, id) {
  return getInContentWithID(content, id, 'fields.text');
};

var getFooterLogo = function getFooterLogo(content) {
  return getInContentWithID(content, 'glowforge-footer-logo', 'fields.svgAsset');
};

var getFooterLinks = function getFooterLinks(content) {
  return (0, _lodash["default"])(content).filter(function (item) {
    return item.fields;
  }).filter(function (item) {
    return (0, _page.getContentType)(item) === 'list';
  }).map(function (item) {
    return {
      title: item.fields.title,
      items: item.fields.listItems.filter(function (listItem) {
        return (0, _page.getContentType)(listItem) === 'buttonLink';
      })
    };
  }).value();
};

var getContentfulGlobalFooterProps = function getContentfulGlobalFooterProps(data) {
  var content = _lodash["default"].get(data, 'fields.content');

  return content && {
    globalFooterLinks: getFooterLinks(content),
    globalFooterLogo: getFooterLogo(content, 'glowforge-footer-logo'),
    globalFooterCopyright: getFooterText(content, 'footer-copyright'),
    globalFooterAddress: getFooterText(content, 'footer-company-address')
  };
};

var _default = getContentfulGlobalFooterProps;
exports["default"] = _default;